module.exports = __webpack_public_path__ + "img/LOCK.8ac17212.svg";